/**
 * Reporting API client.
 *
 * Fetches the admin-only profit baseline — one flat row per billing-customer
 * group × vendor product. The page derives profit-by-product, profit-by-customer,
 * and the client-side what-if simulator from this single dataset. Mirrors the
 * pure-fetch service pattern (relative /api/* URLs proxied to sm4rt-api;
 * types from @techgitter/contracts).
 */

import type { ProfitBaselineResponse, ProfitBaselineRow } from '@techgitter/contracts';

const BASE = '/api/reporting';

async function readJson<T>(response: Response, op: string): Promise<T> {
  if (!response.ok) {
    let detail = '';
    try {
      detail = `: ${(await response.text()).slice(0, 200)}`;
    } catch {
      /* ignore */
    }
    throw new Error(`${op} failed (${response.status} ${response.statusText})${detail}`);
  }
  return (await response.json()) as T;
}

export async function fetchProfitBaseline(signal?: AbortSignal): Promise<ProfitBaselineRow[]> {
  const response = await fetch(`${BASE}/profit-baseline`, {
    headers: { Accept: 'application/json' },
    signal,
  });
  const body = await readJson<ProfitBaselineResponse>(response, 'Load profit baseline');
  return body.items ?? [];
}
